import { useState } from "react";
import LazyYouTubeModal from "./LazyYouTubeModal";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import "./VideoCarousel.css";

const VideoCarousel = ({ videoUrls }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const settings = {
    dots: true,
    lazyload: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: 0,
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
    arrows: false,
  };

  return (
    <div className="video-carousel-container">
      <Slider {...settings}>
        {videoUrls.map((videoUrl, index) => (
          <div key={index} className={`video-slide ${index === currentSlide ? "active" : ""}`}>
            <LazyYouTubeModal
                embedUrl={videoUrl}
                title={`Video ${index + 1}`}
                width="640"
                height="360"
            />
          </div>
        ))}
      </Slider>
      <div className="carousel-dots">
        {videoUrls.map((_, index) => (
            <span
            key={index}
            className={`dot ${index === currentSlide ? "active" : ""}`}
            onClick={() => setCurrentSlide(index)}
            />
        ))}
      </div>
    </div>
  );
};

export default VideoCarousel;
